// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"9de42ede","420":"eb140ec1","453":"d959fd68","954":"8f2a08c2"}[chunkId] + ".chunk.js";
};